import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import moment from 'moment'
import Path from 'routes/path'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import Colors from 'components/styles/colors'
import Icon from 'components/atoms/Icon'
import LabelStatus from 'components/atoms/LabelStatus'
import LinkText from 'components/atoms/LinkText'
import ReservationHelpBlock from 'components/molecules/ReservationHelpBlock'
import ReservationCurrentStatusSection, {
  type PropTypes as ReservationCurrentStatusSectionProps,
} from 'components/organisms/ReservationCurrentStatusSection'
import ReservationDetailSection from 'components/organisms/ReservationDetailSection'
import ReservationHostSection from 'components/organisms/ReservationHostSection'
import { type PropTypes as billStatementCurrentProps } from 'components/molecules/BillStatementCurrent'

const TabSpHeight = 49
const BackLinkHeight = 38
const HeaderHeight = 48
const HeaderSpHeight = 58

const BackLink = styled(Link)`
  display: none;
  ${mediaMin.phone`
    display: block;
    height: ${BackLinkHeight}px;
    padding: ${spacing.small_3}px;
    color: ${Colors.black};
    font-size: ${fontSize.small_2}px;
    line-height: 1.2;
    border-bottom: 1px solid ${Colors.grayE};
    background-color: ${Colors.grayF};
  `};
`
const Container = styled.div`
  height: calc(100% - ${HeaderSpHeight + TabSpHeight}px);
  background-color: ${Colors.white};
  overflow-y: auto;
  ${mediaMin.phone`
    width: 100%;
    height: calc(100vh - ${HeaderHeight}px);
    background-color: ${Colors.grayF};
  `};
`
const MenuListItem = styled.li`
  padding: ${spacing.medium_3}px ${spacing.medium}px;

  &:not(:first-of-type) {
    border-top: 1px solid ${Colors.grayE};
  }

  ${mediaMin.phone`
    padding: ${spacing.medium_3}px ${spacing.medium_2}px;
  `} ${mediaMin.desktop`
    padding: ${spacing.medium_3}px ${spacing.large}px;
  `};
`
const Attribute = styled.div`
  margin-top: ${spacing.small_3}px;
  padding: ${spacing.small}px;
  text-align: center;
  line-height: 1;
  background-color: ${Colors.grayE};
  border-radius: ${borderRadius}px;
`
const LowLinkWrapper = styled.div`
  margin-top: ${spacing.small_3}px;
  text-align: center;
`
const LabelStatusWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`

type PropTypes = {
  hrefBackToReservations: string,
  hrefTokushoho: string,
  isShowContentsSp: boolean,
  reservationId: number,

  reservationCurrentStatusSectionProps: ReservationCurrentStatusSectionProps,
  reservationDetailSectionProps: ReservationDetailSectionProps,
  reservationHostSectionProps: ReservationHostSectionProps,
}

export default function ReservationSidebar(props: PropTypes) {
  return (
    <Fragment>
      <Container>
        <BackLink to={props.hrefBackToReservations}>
          <Icon className="fa fa-angle-left" positionType="left" />
          {i18n.t('page.dashboard.inbox.backToReservations')}
        </BackLink>
        <ul>
          <MenuListItem>
            <ReservationCurrentStatusSection
              {...props.reservationCurrentStatusSectionProps}
            />
          </MenuListItem>
          <MenuListItem>
            <ReservationDetailSection
              {...props.reservationDetailSectionProps}
            />
          </MenuListItem>
          <MenuListItem>
            <ReservationHostSection {...props.reservationHostSectionProps} />
          </MenuListItem>
          <MenuListItem>
            <ReservationHelpBlock />
            <LabelStatusWrapper>
              <LabelStatus fullWidthSp>
                {i18n.t('page.dashboard.inbox.reservationId', {
                  id: props.reservationId,
                })}
              </LabelStatus>
            </LabelStatusWrapper>
            <LowLinkWrapper>
              <LinkText href={props.hrefTokushoho} target="_blank">
                {i18n.t(
                  'page.dashboard.inbox.specifiedCommercialTransactionLaw',
                )}
              </LinkText>
            </LowLinkWrapper>
          </MenuListItem>
        </ul>
      </Container>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/ReservationSidebar/index.jsx